import type { FC, PropsWithChildren } from 'react';
import { cn } from '../../utils/ui';

export interface CardProps extends PropsWithChildren {
    className?: string;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    'data-test-id'?: string;
}

const Card: FC<CardProps> = props => {
    const { children, onClick, className = '', 'data-test-id': dataTestId } = props;

    return (
        <div
            data-test-id={dataTestId}
            onClick={onClick}
            className={cn('transition bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-50 border border-gray-200 dark:border-gray-600', className)}
        >
            {children}
        </div>
    );
};

export default Card;
